import { render } from "./PaneFraction.vue?vue&type=template&id=a5a6c4a6&scoped=true&ts=true"
import script from "./PaneFraction.vue?vue&type=script&lang=ts"
export * from "./PaneFraction.vue?vue&type=script&lang=ts"

import "./PaneFraction.vue?vue&type=style&index=0&id=a5a6c4a6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a6c4a6"]])

export default __exports__